<template>
  <v-card class="tab-card bg-dot-img">
    <v-tabs
      v-model="tab"
    >
     <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" class="tabs-box" >
          Demat Account
      </v-tab>
      <v-tab href="#tab-2" class="tabs-box">
          Trading Account
      </v-tab>

      <v-tab href="#tab-3" class="tabs-box">
          E-Insurance Account
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="tabs-content">
      <v-tab-item
        value="tab-1"
      >
        <dematAccountList />
      </v-tab-item>
      <v-tab-item
        value="tab-2"
      >
        <tradingAccountList />
      </v-tab-item>
      <v-tab-item
        value="tab-3"
      >
       <eInsuranceAccountList />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>

  import dematAccountList from './dematAccount/dematAccountList'; 
  import tradingAccountList from './tradingAccount/tradingAccountList';
  import eInsuranceAccountList from './eInsuranceAccount/eInsuranceAccountList';
 
  export default {
    components: {
     dematAccountList,
     tradingAccountList,
     eInsuranceAccountList,
    },
    data () {
      return {
        tab: this.$route.params.tab,
        text: '',
        tabName: '',
      }
    },
    beforeCreate(){
    },
    methods:{
      CheckTab(tabName)
      {
        //this.tabName = tabName;;
      }
    },
  }
</script>